module.exports = __webpack_public_path__ + "static/media/user.fc82e1ee.png";